<template>
  <div class="page-content" style="padding-top: 4rem">
    <div class="container-fluid">
      <InfoCard :infoData="this.infoDetails" :loading="this.loading" />
      <div class="row">
        <div class="col-lg-12">
          <div class="card" id="orderList">
            <div class="card-header border-0">
              <div class="d-flex align-items-center" style="text-align: left">
                <h5 class="card-title mb-0 flex-grow-1">All Buses</h5>
                <div class="flex-shrink-0">
                  <button
                    type="button"
                    @click="this.$router.push('/add_bus')"
                    class="btn btn-success add-btn"
                  >
                    <i class="ri-add-line align-bottom me-1"></i> Add Bus
                  </button>
                  &nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-info"
                    @click="exportBusesAsCSV()"
                  >
                    <i class="ri-download-line align-bottom me-1"></i> Export
                  </button>
                </div>
              </div>
            </div>
            <div
              class="card-body border border-dashed border-end-0 border-start-0"
            >
              <form>
                <div class="row g-3">
                  <div class="col-xxl-2 col-sm-6">
                    <div class="search-box">
                      <input
                        type="text"
                        class="form-control search"
                        v-model="searchByRegisterNo"
                        @keydown.enter.prevent
                        @input="fetchList(1)"
                        placeholder="Enter Bus No"
                      />
                      <i class="ri-search-line search-icon"></i>
                    </div>
                  </div>
                  <div class="col-xxl-2 col-sm-6">
                    <div class="search-box">
                      <input
                        type="text"
                        class="form-control search"
                        v-model="seachByPhoneNumber"
                        keydown.enter.prevent
                        @input="fetchList(1)"
                        placeholder="Enter Phone Number"
                      />
                      <i class="ri-search-line search-icon"></i>
                    </div>
                  </div>
                  <div
                    class="col-xxl-2 col-sm-4"
                    v-if="ldata !== null && ldata.role === 'superadmin'"
                  >
                    <div>
                      <select
                        class="form-control"
                        v-model="search_sort_by"
                        @keydown.enter.prevent
                        v-on:change="fetchList(1)"
                        name="choices-single-default"
                        id="idStatus"
                      >
                        <option value="" selected>Sort By</option>
                        <option
                          v-for="(option, index) in sortOptions"
                          :key="index"
                          :value="option.value"
                        >
                          {{ option.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="card-body pt-0">
              <div class="mt-5">
                <div class="table-responsive table-card mb-1">
                  <div class="noresult" v-if="loading">
                    <rb-loading-table />
                  </div>
                  <div v-else>
                    <rb-data-table
                      :ldata="ldata"
                      :headers="headers"
                      :tableData="formattedBuses"
                      @edit="updateBus"
                      @delete="delCoupon1"
                    />
                  </div>
                </div>
                <div class="d-flex justify-content-end pr-4" v-if="!loading">
                  <div class="me-3">
                    <select
                      class="form-select w-auto"
                      v-model="limitProxy"
                      @change="fetchList(1)"
                    >
                      <template
                        v-for="(role, index) in paginationOptions"
                        :key="index"
                      >
                        <option :value="role">{{ role }}</option>
                      </template>
                    </select>
                  </div>
                  <div
                    class="pagination-wrap hstack gap-2"
                    style="display: flex"
                  >
                    <a
                      class="page-item pagination-prev px-4"
                      v-if="pageNo > 1"
                      @click="fetchList(pageNo - 1)"
                      href="javascript:void(0)"
                    >
                      <i class="ri-arrow-left-line"></i>
                    </a>
                    <ul
                      class="pagination listjs-pagination mb-0"
                      v-if="buses.length > 0"
                    >
                      <li class="active">
                        <a class="page" href="javascript:void(0)">{{
                          pageNo
                        }}</a>
                      </li>
                      <li>
                        <a
                          v-if="buses.length >= limit"
                          class="page"
                          href="javascript:void(0)"
                          @click="fetchList(pageNo + 1)"
                          >{{ pageNo + 1 }}</a
                        >
                      </li>
                    </ul>
                    <a
                      v-if="buses.length >= limit"
                      class="page-item pagination-next px-4"
                      href="javascript:void(0)"
                      @click="fetchList(pageNo + 1)"
                    >
                      <i class="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LoaderLoading v-if="overallLoading" />
    </div>
  </div>
</template>

<script>
import { getAllBuses } from "@/apis/busdetailsapis";
import { getBusById } from "@/apis/busdetailsapis";
import { getOperatorById } from "@/apis/operator";
import listMixin from "@/mixins/listMixin";

export default {
  name: "busesList",
  mixins: [listMixin],

  data() {
    return {
      search_sort_by: "",
      sortOptions: [
        { value: "newest", label: "Newest Bus" },
        { value: "bookings", label: "Bookings Highest to Lowest" },
        { value: "fleet_size", label: "Fleet Size Highest to Lowest" },
        { value: "revenue", label: "Revenue Highest to Lowest" },
      ],
      seachByPhoneNumber: null,
      searchByRegisterNo: null,

      buses: [],

      headers: [
        {
          name: "Bus No",
        },
        {
          name: "Created Date",
        },
        {
          name: "Phone Number",
        },
        {
          name: "Route Details",
        },
        {
          name: "Revenue",
        },
        {
          name: "Bookings",
        },
        {
          name: "onboarding Progress",
        },
        {
          name: "Status",
          auth: true,
        },
        {
          name: "Action",
          auth: true,
        },
      ],
      infoDetails: [
        {
          title: "Active Buses",
          icon: "ri-group-line",
          count: 0,
        },
        {
          title: "Pending Buses",
          icon: "ri-user-follow-line",
          count: 0,
        },
        {
          title: "Total Buses",
          icon: "ri-computer-line",
          count: 0,
        },
      ],
    };
  },
  methods: {
    async fetchList(pageNo) {
      const isNewest = this.search_sort_by === "newest";
      const response = await this.fetch(pageNo, getAllBuses, {
        phoneNumber: this.seachByPhoneNumber,
        regNo: this.searchByRegisterNo,
        sort_by: this.search_sort_by,
        ascending: !isNewest,
      });

      this.buses = response.data;
      this.infoDetails[0].count = response?.active_buses;
      this.infoDetails[1].count = response?.in_complete_buses;
      this.infoDetails[2].count = response?.total_buses;
    },

    exportBusesAsCSV() {
      const fields = [
        "busNo",
        "created_at",
        "mobile",
        "routeDetails",
        "revenue",
        "bookings",
        "onbordingProgress",
      ];
      this.$exportCsv(this.formattedBuses, "Bus.csv", fields);
    },

    async updateBus(bus) {
      const response = await getBusById(bus.id);
      if (response.success) {
        const response1 = await getOperatorById(response.data.operator_id);
        if (response1.success) {
          localStorage.setItem("user_edit_data", JSON.stringify(response.data));
          this.$router.push({
            path: `/add_operator/${response1.data.phone_number}`,
          });
        }
      } else {
        this.$refs.toast.showToast(response.message, "error");
      }
    },
  },

  computed: {
    formattedBuses() {
      return this.buses.map((bus) => ({
        id: bus.bus_id,
        busNo: bus.reg_no,
        created_at: bus.created_at
          ? new Date(bus.created_at).toLocaleString()
          : "N/A",
        mobile: bus.phone_number || "N/A",
        routeDetails:
          bus.route && bus.route.length > 0
            ? `${bus.route[0].source}-${bus.route[0].destination}`
            : "N/A",
        revenue: bus.total_revenue || 0,
        bookings: bus.total_bookings || 0,
        onbordingProgress: bus.onboarding_progress || "100%",
        status: bus.is_active ? "Active" : "In Active",
      }));
    },
  },
};
</script>
